import fp from 'lodash/fp';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { testingSets } from './config/testingSets';
import TestingSetControl from './testingSetControl';

const PressureTest = () => {
  return <div id='pressure-test'>
    {
      fp.map(
        (testingSet) => {
          return <TestingSetControl {...{
            key: testingSet.name,
            testingSet
          }} />
        }
      )(testingSets)
    }
  </div>
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(PressureTest)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/pressureTest.js